import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "./index.css";
import { flushExpenses } from "./utils/offlineExpenses";

ReactDOM.createRoot(document.getElementById("root")).render(<App />);

// Reload installed and long-running PWAs when a new production bundle lands.
const BUILD_VERSION_KEY = "ebek-expense-build-version";
async function refreshForNewBuild() {
  try {
    const response = await fetch(`/build-version.json?t=${Date.now()}`, { cache: "no-store" });
    if (!response.ok) return;
    const { version } = await response.json();
    if (!version) return;
    const previous = localStorage.getItem(BUILD_VERSION_KEY);
    localStorage.setItem(BUILD_VERSION_KEY, version);
    if (previous && previous !== version) window.location.reload();
  } catch {
    // Offline use is supported; the next interval or focus event retries.
  }
}

if (process.env.NODE_ENV === "production") {
  refreshForNewBuild();
  window.setInterval(refreshForNewBuild, 60 * 1000);
  window.addEventListener("focus", refreshForNewBuild);
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible") refreshForNewBuild();
  });
}

window.addEventListener("online", () => flushExpenses().catch(() => {}));
if (navigator.onLine) flushExpenses().catch(() => {});

// Register service worker for PWA builds only. Local dev unregisters stale workers.
if (process.env.NODE_ENV === "production" && "serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js", { updateViaCache: "none" })
      .then((registration) => {
        registration.update().catch(() => {});
        console.log("SW registered");
      })
      .catch((err) => console.log("SW registration failed:", err));
  });

  // Apply a newly deployed service worker immediately. Reload only once so the
  // installed PWA cannot remain on an obsolete expense form after deployment.
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    const reloadKey = "ebek-expense-sw-reloaded";
    if (sessionStorage.getItem(reloadKey)) return;
    sessionStorage.setItem(reloadKey, "1");
    window.location.reload();
  });
} else if ("serviceWorker" in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then((registrations) => registrations.forEach((registration) => registration.unregister()))
    .catch(() => {});
}
